<template>
  <div>
    <div v-if="filter.children && !filter.name.includes('_del') && filter.name !== 'tempmaincat'" class="filter-category">
      <b-row>
        <b-col cols="7">
          <b-btn
            variant="link-dark"
            size="sm"
            class="font-weight-bold"
            :class="{
              collapsed: filter.open,
              'filter-category-name': filter.type === 'category',
              'filter-subcategory-name': filter.type === 'subcategory',
              'text-muted': filter.empty
            }"
            :aria-expanded="filter.open ? 'true' : 'false'"
            @click="toggleFilterCategoryOpen"
            >{{ filter.name }} 
            <i 
              class="fas fa-tachometer-alt"
              variant="info" 
              v-if="isOnDiscover(filter)"
            ></i>
            </b-btn
          >
        </b-col>
        <b-col class="text-right">
          <b-btn
            variant="link-dark"
            size="sm"
            :class="{
              collapsed: !filter.open,
              'text-muted': filter.empty
            }"
            :aria-expanded="filter.open ? 'true' : 'false'"
            @click="toggleFilterCategoryOpen"
          >
            <i v-if="filter.open" class="fa fa-angle-up" />
            <i v-else class="fa fa-angle-down" />
          </b-btn>
          <b-btn variant="link-dark" size="sm" @click="editCategory(filter)">
            <i class="fa fa-pencil-alt" />
          </b-btn>
        </b-col>
      </b-row>

      <b-collapse :id="'collapse-' + filter._id" v-model="filter.open">
        <div v-for="child in filter.children" :key="child._id">
          <draggable
            v-if="child.children"
            :list="filterDropped"
            :group="{ name: 'query', pull: false, put: true }"
            :sort="false"
            @change="droppedFilter(child)"
          >
            <FilterCategory :filter="child"> </FilterCategory>
          </draggable>
          <FilterItem v-if="!child.children && !child.name.includes('_del') && !filterDuplicates.includes(child._id)" :filter="child"></FilterItem>
        </div>
      </b-collapse>
    </div>
    <!--
    <div v-else rel="Just-to-get-the-issue">
      <FilterItem v-if="!child.children && !child.name.includes('_del') && !filterDuplicates.includes(child._id)" :key="filter._id" :filter="filter"></FilterItem>
    </div>
    -->
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import FilterItem from "./FilterItem";
import _ from "lodash";

export default {
  name: "FilterCategory",
  components: {
    FilterItem,
    draggable
  },
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterDropped: []
    };
  },
  computed: {
    ...mapState({
      filterDuplicates: state => state.filter.filterDuplicates,
      discoverCategories: (state) => state.setting.dataSettings.focus.lastQuery
    }),
  },
  methods: {
    ...mapActions(["toggleFilterOpen", "saveFilter"]),
    toggleFilterCategoryOpen() {
      this.filter.open = !this.filter.open;
      this.toggleFilterOpen({
        filter: this.filter
      });
    },
    editCategory(category) {
      EventBus.$emit("editCategory", category);
    },
    droppedFilter(e) {
      let filter = {
        type: "filter",
        _id: this.filterDropped[0]._id
      };
      this.saveFilter({
        filter: filter,
        subcategory: { _id: e._id },
        category: { _id: e.parent_id }
      });
      this.filterDropped = [];
    },
    /*
    isOnDiscover(filter){
      let response = false;
      if(filter.type === 'category'){
        let cat = this.discoverCategories.find(f => { return f._id === filter._id })
        if(cat.visibility && !(cat.visibility.discover)){
          response = false
        }
        else{
          response = true
        }
      }
      else{
        let cindex = _.findIndex(this.discoverCategories, f => f._id === filter.parent_id )
        let subcat = this.discoverCategories[cindex].children.find(f => { return f._id === filter._id })
        if(subcat.visibility && !(subcat.visibility.discover)){
          response = false
        }
        else{
          response = true
        }
      }
      return response 
    },*/
    isOnDiscover(filter){
      if(this.discoverCategories.length > 0){
        return !this.discoverCategories.includes(filter._id)
      }
      else{
        return true
      }
    },
    checkChildrenVisibility(list){
      //let visible = list.filter(l => { return !l.visibility || l.visibility.discover });
      let visible = list.filter(l => { return !this.discoverCategories.includes(l._id) && !l.name.includes('_del')});
      return visible.length > 0
    }
  }
};
</script>
